import { gql } from "urql";
export const CreateChatRoomGroupMutation = gql `
    mutation CreateChatRoomGroup($input: ChatRoomGroupCreateInput!) {
        chatRoomGroups {
            createGroup(input: $input) {
                chatRoomGroupId
                userId
                name
                sortOrder
                createdAt
                updatedAt
            }
        }
    }
`;
export const UpdateChatRoomGroupMutation = gql `
    mutation UpdateChatRoomGroup($input: ChatRoomGroupUpdateInput!) {
        chatRoomGroups {
            updateGroup(input: $input) {
                chatRoomGroupId
                name
                sortOrder
                updatedAt
            }
        }
    }
`;
export const DeleteChatRoomGroupMutation = gql `
    mutation DeleteChatRoomGroup($chatRoomGroupId: String!) {
        chatRoomGroups {
            deleteGroup(chatRoomGroupId: $chatRoomGroupId)
        }
    }
`;
export const ReorderChatRoomGroupsMutation = gql `
    mutation ReorderChatRoomGroups($input: [ChatRoomGroupReorderInput!]!) {
        chatRoomGroups {
            reorderGroups(input: $input) {
                chatRoomGroupId
                sortOrder
            }
        }
    }
`;
export const AssignRoomToGroupMutation = gql `
    mutation AssignRoomToGroup(
        $chatRoomGroupId: String!
        $chatRoomId: String!
        $sortOrder: Int
    ) {
        chatRoomGroups {
            assignRoom(
                chatRoomGroupId: $chatRoomGroupId
                chatRoomId: $chatRoomId
                sortOrder: $sortOrder
            )
        }
    }
`;
export const UnassignRoomFromGroupMutation = gql `
    mutation UnassignRoomFromGroup(
        $chatRoomGroupId: String!
        $chatRoomId: String!
    ) {
        chatRoomGroups {
            unassignRoom(
                chatRoomGroupId: $chatRoomGroupId
                chatRoomId: $chatRoomId
            )
        }
    }
`;
